module.exports = __webpack_public_path__ + "img/img7.461c60c9.png";